import React from 'react';
import { LIVE_MATCH_STRIP_ITEMS } from '../constants/liveMatches';
import './LiveMatchStrip.scss';

const LiveMatchStrip: React.FC = () => {
  const doubled = [...LIVE_MATCH_STRIP_ITEMS, ...LIVE_MATCH_STRIP_ITEMS];
  return (
    <div className="logged-home-live-strip">
      <div className="logged-home-live-strip-inner">
        {doubled.map((item, i) => (
          <span key={`${item.id}-${i}`} className="logged-home-live-strip-item">
            {item.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default LiveMatchStrip;
